import { createFileRoute } from '@tanstack/react-router'
import { Planning } from '../screens/Planning'

export const Route = createFileRoute('/planning')({
  component: Planning,
})
